// Documents
export const DOCUMENTS = "DOCUMENTS";

// Alerts
export const MINE_ALERTS = "MINE_ALERTS";